import { render, staticRenderFns } from "./AnalyticsPopularProducts.vue?vue&type=template&id=607b937b&scoped=true&"
import script from "./AnalyticsPopularProducts.vue?vue&type=script&lang=js&"
export * from "./AnalyticsPopularProducts.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsPopularProducts.vue?vue&type=style&index=0&id=607b937b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607b937b",
  null
  
)

export default component.exports